import { useQuery } from '@tanstack/react-query';

import identity from 'lodash/identity';
import pickBy from 'lodash/pickBy';

import {
  HrApiHrEmployeeDetailsNoPaginationGetRequest,
  useApi,
} from '@sbv-clients/data-access-api';
import { useAccessToken } from '@sbv-clients/ui-shared';

export const useEmployeesGetByDepartmentAndPosition = (
  body: HrApiHrEmployeeDetailsNoPaginationGetRequest
) => {
  const { isMultiFacility } = useAccessToken();
  const api = useApi();
  return useQuery({
    queryKey: ['filter-employee-by-department-and-position', body],
    queryFn: async () => {
      const params = pickBy(body, identity);
      return api.hrApi
        .hrEmployeeDetailsNoPaginationGet({
          ...params,
        })
        .then((response) => response?.data?.data ?? []);
    },
    retry: false,
    refetchOnWindowFocus: false,
    enabled:
      ((isMultiFacility && Boolean(body.facilityId)) || !isMultiFacility) &&
      Boolean(body.departmentId),
  });
};

export const useEmployeesGet = (
  body?: HrApiHrEmployeeDetailsNoPaginationGetRequest
) => {
  const { isMultiFacility } = useAccessToken();
  const api = useApi();
  return useQuery({
    queryKey: ['filter-employees', body],
    queryFn: async () => {
      return api.hrApi
        .hrEmployeeDetailsNoPaginationGet(body)
        .then((response) => response?.data?.data ?? []);
    },
    retry: false,
    refetchOnWindowFocus: false,
    enabled:
      (!isMultiFacility || (isMultiFacility && Boolean(body?.facilityId))) &&
      Boolean(body?.departmentId),
  });
};
